<div class="notification-transparent-background" [ngClass]="notificationBackgroundClass"
  (click)="toggleNotificationPopup()"></div>

<nav class="navbar navbar-default whiteBackground" *ngIf="!isInvoicePage">
  <div class="container-fluid d-flex">
    <div class="navbar-header">
      <img *ngIf="!showFixMeLogo" class="logoIcon"  [src]="company.logo &&isSuccessOrFailUpaymentUrl ? bashostUrl+'/'+company.logo :'assets/Images/servio_logo.svg' "  [routerLink]="'/'" />
      <img  *ngIf="showFixMeLogo" class="logoIcon" src="assets/Images/FixMelogo.png" [routerLink]="'/'" />
    </div>

    <div *ngIf="isLoggedin &&!isSuccessOrFailUpaymentUrl">
      <ul class="nav navbar-nav">
        <!-- <ng-container>
          <a class="header-anchor" [routerLink]="'/dashboard'">
            Dashboard
          </a>
        </ng-container> -->

     <ng-container *ngFor="let menuItem of menu; let i = index">

  <ng-container *ngIf="menuItem.display && hasVisibleChildren(menuItem)">
    <a *ngIf="hasPermission(menuItem.permission, menuItem.notAdmin) || isRoleExist(role, menuItem.role)"
       class="header-anchor"
       [ngClass]="{'isActive': menuItem.isAcive}"
       [matMenuTriggerFor]="menu">
      {{ menuItem.name | translate }}
    </a>

    <mat-menu #menu="matMenu" class="contract-menu">
      <ng-container *ngFor="let item of menuItem.childrens">

        <a *ngIf="showTrackingLinks && item.route === 'tracking' && item.display"
           mat-menu-item
           (click)="goTotrackingLink()">
          {{ item.name | translate }}
        </a>

        <button *ngIf="hasVisibleChildren(item)"
                mat-menu-item
                [matMenuTriggerFor]="subMenu">
          {{ item.name | translate }}
        </button>

        <a *ngIf="!item.childrens?.length 
                  && item.route !== 'tracking'
                  && item.display
                  && (hasPermission(item.permission, item.notAdmin) || isRoleExist(role, item.role))
                  && (item.config == null || item.config)"
           routerLinkActive="active-nav"
           [routerLinkActiveOptions]="{ exact: true }"
           mat-menu-item
           [routerLink]="item.route">
          {{ item.name | translate }}
        </a>

        <mat-menu #subMenu="matMenu" class="contract-submenu">
          <ng-container *ngFor="let sub of item.childrens">

            <a *ngIf="showTrackingLinks && sub.route === 'tracking' && sub.display"
               mat-menu-item
               (click)="goTotrackingLink()">
              {{ sub.name | translate }}
            </a>

            <a *ngIf="sub.display
                      && sub.route !== 'tracking'
                      && (hasPermission(sub.permission, sub.notAdmin) || isRoleExist(role, sub.role))
                      && (sub.config == null || sub.config)"
               routerLinkActive="active-nav"
               [routerLinkActiveOptions]="{ exact: true }"
               mat-menu-item
               [routerLink]="sub.route">
              {{ sub.name | translate }}
            </a>

          </ng-container>
        </mat-menu>

      </ng-container>
    </mat-menu>
  </ng-container>

  <!-- العناصر بدون children -->
  <a *ngIf="(hasPermission(menuItem.permission, menuItem.notAdmin) || isRoleExist(role, menuItem.role))
            && menuItem.childrens.length == 0
            && menuItem.display
            && (menuItem.config == null || menuItem.config)"
     class="header-anchor"
     [ngClass]="{'isActive': menuItem.isAcive}"
     [routerLink]="menuItem.route">
    {{ menuItem.name | translate }}
  </a>

  <!-- الحالة الخاصة بـ tracking في المستوى الرئيسي -->
  <a *ngIf="showTrackingLinks && menuItem.route === 'tracking' && menuItem.display"
     class="header-anchor"
     (click)="goTotrackingLink()">
    {{ menuItem.name | translate }}
  </a>

</ng-container>

      </ul>

    </div>

    <div class="RightPart" *ngIf="authenticationService.isLoggedIn()">

      <img class="Avatar" src="assets/Images/user.png" [matMenuTriggerFor]="menu" />
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="profile()">{{'Profile' | translate}}</button>
        <button mat-menu-item (click)="LogoutAll()">{{'Logout' | translate}}</button>
      </mat-menu>

      <div class="notification-section">
        <button class="notification-btn" [ngClass]="toggelingNotificationIconClass" (click)="toggleNotificationPopup()">
          <i class="fa fa-bell-o bell"></i>
          <div class="flex-notification" [hidden]="!sharedNotificationService.notificationCount">
            <span class="font-size-11">{{sharedNotificationService.notificationCount}}</span>
            <!-- <i class="fa fa-circle dot"></i> -->
          </div>
        </button>
        <div [hidden]="!toggleNotification" [ngClass]="{'rtl-notification-body': translateService.currentLang == 'ar' }"
          class="notification-main-container notification-body uk-padding-small uk-animation-slide-top-small">
          <div *ngIf="!isloading">
            <div *ngFor="let notification of notifications;let i =index" (click)="onNotificationClick(notification, i)"
              class="pointer" [ngClass]="{'read':notification.isRead}">
              <p class="notification-content">{{notification.body}}</p>

              <div class="d-flex notification-container">
                <small>{{notification.createdDate }}</small>
                <div class="approval-box"
                  *ngIf="notification.notificationType === 'Change order priority' && !(notification.isActionTaken)">
                  <i class="fa" pTooltip="{{'approve' | translate}}" tooltipPosition="top" hideDelay="200"
                    (click)="onApproveRequest($event,notification,i,true)">&#xf058;</i>
                  <i class="fa" pTooltip="{{'disapprove' | translate}}" tooltipPosition="top" hideDelay="200"
                    (click)="onApproveRequest($event,notification,i,false)">&#xf057;</i>
                </div>
              </div>
              <hr>
            </div>
            <div [hidden]="!notifications.length" class="footer-notification-center">
              <p class="show-all" (click)="onMarkAllAsRead()">{{'Mark All Read' | translate}}</p>
              <p class="show-all" [routerLink]="['dispatcher/notifications']" (click)="toggleNotificationBody()">
                {{'Show All' | translate}}</p>
            </div>
          </div>

          <p-progressSpinner class="loading-spinner" *ngIf="isloading"></p-progressSpinner>
          <p *ngIf="!notifications.length && !isloading">{{'No notifications available' | translate}}</p>
        </div>
      </div>

      <div class="AfterLogin">
        <span class="nameLogged">{{'Welcome' | translate}} , {{authenticationService.CurrentUser().data.name}} </span>
        <br />
        <button class="LogOut" (click)="LogoutAll()" [ngClass]="{'disabled':finishLoggingOut}">{{'Log Out' |
          translate}}</button>
      </div>
    </div>

  </div>
</nav>
